var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "sidebar-title",
      class: [
        `sidebar-title--${_vm.size}`,
        { "sidebar-title--no-border": _vm.noBorder },
      ],
    },
    [_vm._v("\n  " + _vm._s(_vm.title) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }